import { AbstractClient } from './AbstractClient';
import { CarrierListResponse, LineType } from '../../types';

export class CarrierClient extends AbstractClient {
  fetchList = this.createGetHandler<
    CarrierListResponse,
    { query: { insuranceLine: LineType } }
  >('/');
}
